import React, { useEffect, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { AnimatePresence, motion } from "framer-motion"
import { FiInstagram } from "react-icons/fi";
import { TiSocialTwitterCircular } from "react-icons/ti";
import { RiFacebookCircleLine } from "react-icons/ri";
import { MdCategory, MdExpandMore, MdExpandLess } from "react-icons/md";
import CategoryTree from "../layouts/categoryTree";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";

//import { useSelector } from "react-redux";
import SearchBar from "./SearchBar";

function Navbar() {
  const [categories, setCategories] = useState([]);
  const [clickCategory, setClickCategory] = useState(false);
  const [hover, setHover] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  //const cart = useSelector(state => state.cart);
  //const itemCount = cart?.reduce((acc, item) => acc + item.qty, 0) || 0;

  useEffect(() => {
    axios.get('api/tree/categorylist').then(res => {
      setCategories(res.data.categories);
    });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handlePopHover = (e) => {
    setHover(!hover);
  }

  const showCategory = () => {
    setClickCategory(!clickCategory);
  }

  const navLinks = [
    { name: 'Home', path: '/', icon: null },
    { name: 'About Us', path: '/about', icon: null },
    { name: 'Products', path: '/products', icon: null, hasDropdown: true },
    { name: 'Contact Us', path: '/quote', icon: null },
    { name: 'FAQ', path: '/faq', icon: null },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className={`sticky top-0 z-0 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-white shadow-sm'}`}>
      {/* Top Bar */}
      <div className="hidden lg:block bg-gradient-to-r from-gray-900 to-gray-800 text-white text-sm">
        <div className="max-w-7xl mx-auto px-4 py-2 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <span className="text-xs">Free Shipping on orders over Rs 2000</span>
            <span className="text-xs">|</span>
            <span className="text-xs">24/7 Customer Support</span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/myorders" className="text-xs hover:text-gray-300 transition">Track Order</Link>
            <Link to="/wishlist" className="text-xs hover:text-gray-300 transition">Wishlist</Link>
            <div className="flex items-center gap-2">
              <Link to="https://www.facebook.com/Poshinds" target="_blank" className="hover:text-gray-300 transition">
                <RiFacebookCircleLine size={16} />
              </Link>
              <Link to="https://www.instagram.com/poshinds/" target="_blank" className="hover:text-gray-300 transition">
                <FiInstagram size={15} />
              </Link>
              <Link to="#" target="_blank" className="hover:text-gray-300 transition">
                <TiSocialTwitterCircular size={18} />
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-8">
        <div className="flex justify-around items-center h-16 ">
          
          {/* Logo */}
          <div className="lg:flex xl:flex hidden">
              {/* Departments Dropdown Button */}
        <div className="relative">
          <button
            onClick={showCategory}
            className={`mt-1 px-4 py-2  rounded-full flex items-center gap-2 transition-all duration-300 ${
              clickCategory ? 'bg-yellow-500 text-black shadow-md' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            <MdCategory size={20} />
            <span className="text-sm font-medium">Departments</span>
            {clickCategory ? <MdExpandLess size={18} /> : <MdExpandMore size={18} />}
          </button>

          {/* Categories Dropdown */}
          <AnimatePresence>
            {clickCategory && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.2 }}
                className="absolute top-12 left-0 w-80 bg-white rounded-xl shadow-2xl border border-gray-100 z-50 overflow-hidden"
              >
                <div className="p-4 border-b border-gray-100 bg-gradient-to-r from-gray-50 to-white">
                  <h3 className="font-semibold text-gray-800">All Categories</h3>
                  <p className="text-xs text-gray-500 mt-1">Browse our product range</p>
                </div>
                <div className="max-h-96 overflow-y-auto p-2">
                  <CategoryTree categories={categories} showCategory={showCategory} />
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

          </div>
<div className="lg:hidden xl:hidden md:hidden  flex-1 max-w-2xl mx-4">
              <SearchBar />
            </div>
          {/* Desktop Navigation Links */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <div key={link.name} className="relative group">
                {link.hasDropdown ? (
                  <button
                    onClick={handlePopHover}
                    className={`flex items-center gap-1 text-sm font-medium transition-colors duration-200 ${
                      isActive(link.path) ? 'text-black' : 'text-gray-700 hover:text-black'
                    }`}
                  >
                    {link.name}
                    <IoIosArrowDown className={`text-xs transition-transform duration-200 ${hover ? 'rotate-180' : ''}`} />
                  </button>
                ) : (
                  <Link
                    to={link.path}
                    className={`text-sm font-medium transition-colors duration-200 ${
                      isActive(link.path) ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                    }`}
                  >
                    {link.name}
                  </Link>
                )}
              </div>
            ))}
          </div>

         
        </div>

      

        {/* Products Mega Menu */}
        <AnimatePresence>
          {hover && (
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.2 }}
              className="absolute left-0 right-0 top-full mt-0 bg-white shadow-2xl border-t border-gray-100 z-40"
            >
              <div className="max-w-7xl mx-auto px-4 py-8">
                <div className="grid grid-cols-4 gap-8">
                  {categories.slice(0, 4).map((category, idx) => (
                    <div key={idx}>
                      <Link
                        to={`/products/${category.id}`}
                        onClick={handlePopHover}
                        className="text-sm font-semibold text-gray-800 hover:text-blue-600 transition-colors block mb-3"
                      >
                        {category.name}
                      </Link>
                      {category.children?.slice(0, 5).map((child, childIdx) => (
                        <Link
                          key={childIdx}
                          to={`/products/${child.id}`}
                          onClick={handlePopHover}
                          className="text-xs text-gray-500 hover:text-blue-600 transition-colors block py-1"
                        >
                          {child.name}
                        </Link>
                      ))}
                      {category.children?.length > 5 && (
                        <Link
                          to={`/products/${category.id}`}
                          className="text-xs text-blue-600 hover:text-blue-700 font-medium mt-2 block"
                        >
                          View all →
                        </Link>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </nav>
  );
}

export default Navbar;